import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import PainPoints from './components/PainPoints';
import Services from './components/Services';
import Workshop from './components/Workshop';
import Mission from './components/Mission';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Add Organization Schema
    const orgSchema = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "全力以赴企業團建有限公司",
      "url": siteUrl,
      "logo": `${siteUrl}/vite.svg`,
      "description": "專注於打造高績效團隊的企業團建服務公司，提供客製化企業團建、工作坊、主管帶隊訓練等服務。",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "TW"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": ["zh-TW"]
      }
    };

    // Add WebSite Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "全力以赴企業團建",
      "url": siteUrl,
      "description": "打造會做事的團隊，提供專業企業團建與團隊訓練服務",
      "inLanguage": "zh-TW"
    };

    // Add Service Schema
    const serviceSchema = {
      "@context": "https://schema.org",
      "@type": "Service",
      "serviceType": "企業團建訓練",
      "provider": {
        "@type": "Organization",
        "name": "全力以赴企業團建有限公司"
      },
      "areaServed": {
        "@type": "Country",
        "name": "Taiwan"
      },
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "企業團建服務",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "客製化燃點式企業團建",
              "description": "根據企業目標設計的客製化團建活動，包含室內挑戰、戶外高強度訓練等多種形式"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "高績效團隊工作坊",
              "description": "針對跨部門協作、衝突對話、高效溝通等主題的實戰工作坊"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "主管帶隊實戰團建",
              "description": "專為主管設計的團隊領導與管理訓練"
            }
          }
        ]
      }
    };

    // Add FAQ Schema
    const faqSchema = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "企業團建可以解決什麼問題？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "企業團建可以解決團隊執行力不足、部門之間互相推責任、主管帶人困難、員工不夠主動等問題。我們的團建不只是吃喝拍照，而是透過挑戰與對話，讓團隊產生真正的改變。"
          }
        },
        {
          "@type": "Question",
          "name": "全力以赴企業團建與其他團建公司有什麼不同？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "我們不是在辦活動，而是在打造會做事的團隊。我們的團建會讓人流汗、卡關、對話、甚至衝突，但也會讓人看見彼此真正的力量。我們把玩變成訓練，把體驗變成學習，把感動變成行動。團建結束不是終點，而是改變的起點。"
          }
        },
        {
          "@type": "Question",
          "name": "團建活動需要多長時間？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "我們提供彈性的時間安排，從半天工作坊到1-3天的主題式沉浸團建都有。具體時間會根據企業目標、團隊規模和需求來客製化設計。"
          }
        }
      ]
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(orgSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(websiteSchema);
    document.head.appendChild(script2);

    const script3 = document.createElement('script');
    script3.type = 'application/ld+json';
    script3.text = JSON.stringify(serviceSchema);
    document.head.appendChild(script3);

    const script4 = document.createElement('script');
    script4.type = 'application/ld+json';
    script4.text = JSON.stringify(faqSchema);
    document.head.appendChild(script4);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
      document.head.removeChild(script4);
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <About />
      <PainPoints />
      <Services />
      <Workshop />
      <Mission />
      <Contact />
      <Footer />
    </div>
  );
}
